'use client';

import { toast, ToastContent, ToastOptions } from 'react-toastify';
import { ToastSuccessIcon } from '@/components';

const MOBILE_BREAKPOINT = 959;
const MOBILE_AUTO_CLOSE_MS = 3000;

const isMobileViewport = () =>
  typeof window !== 'undefined' && window.innerWidth <= MOBILE_BREAKPOINT;

const getMobileSuccessOptions = (): ToastOptions => ({
  className: 'toast-mobile toast-mobile--success',
  position: 'top-center',
  autoClose: MOBILE_AUTO_CLOSE_MS,
  hideProgressBar: true,
  closeButton: false,
  pauseOnHover: false,
  pauseOnFocusLoss: false,
  draggable: false,
  closeOnClick: false,
  icon: <ToastSuccessIcon aria-hidden="true" />,
});

export const showToast = {
  success: (content: ToastContent, options?: ToastOptions) => {
    if (!isMobileViewport()) {
      return toast.success(content, options);
    }

    const mobileOptions = { ...options, ...getMobileSuccessOptions() };
    const toastId = toast.success(content, mobileOptions);

    window.setTimeout(() => {
      toast.dismiss(toastId);
    }, MOBILE_AUTO_CLOSE_MS);

    return toastId;
  },
};
